import { render, staticRenderFns } from "./jinjiangCardStats.vue?vue&type=template&id=42141d82&scoped=true"
import script from "./jinjiangCardStats.vue?vue&type=script&lang=js"
export * from "./jinjiangCardStats.vue?vue&type=script&lang=js"
import style0 from "./jinjiangCardStats.vue?vue&type=style&index=0&id=42141d82&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42141d82",
  null
  
)

export default component.exports